import { Box, Typography, TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import { useDispatch } from "react-redux";
import { updateFileField } from "../../../ReduxStore/UserSlice";
import DragDropFileUpload from "./DragDropFileUpload";
import { useState } from "react";
import { showToast } from "../Util/Util";


const DocumentUploadSection = ({
  control,
  title,
  errors,
  helptext,
  name,
  validationRule,
  value,
  multiple = false,
  requireDocumentName = false,
}) => {
  const dispatch = useDispatch();
  const [documentName, setDocumentName] = useState("");
  const [documentNameError, setDocumentNameError] = useState("");

  const validateDocumentName = (name) => {
    const trimmed = (name || "").trim();
    if (!trimmed) {
      setDocumentNameError("Document name is required");
      return false;
    }
    setDocumentNameError("");
    return true;
  };
  
  const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  const handleFileChange = async (selectedFile) => {
    try {
      if (selectedFile) {
        const finalName =
          requireDocumentName && documentName
            ? documentName.replace(/\s+/g, "_")
            : null;
        if (Array.isArray(selectedFile)) {
          const base64Files = await Promise.all(selectedFile.map(async (file) => {
            const base64 = await fileToBase64(file);
            return {
              base64,
              filename: finalName || file.name,
            };
          }));
          dispatch(
            updateFileField({
              field: name,
              value: base64Files,
            })
          );
        } else {
          const base64 = await fileToBase64(selectedFile);
          dispatch(
            updateFileField({
              field: name,
              value: {
                base64,
                filename: finalName || selectedFile.name,
              },
            })
          );
        }
      }
    } catch (error) {
      console.error("Failed to convert file to base64:", error);
    }
  };

    return (
    <Box
      sx={{
        p: 3,
        border: "1px solid #e0e0e0",
        borderRadius: 1,
        mb: 2,
        backgroundColor: "white",
      }}
    >
      <Typography variant="h6" sx={{ mb: 2 }}>
        {title}
      </Typography>
      
      {requireDocumentName && (
        <TextField
          fullWidth
          label="Document Name"
          placeholder="Enter document name (e.g., Bank Statement, Invoice, etc.)"
          value={documentName}
          onChange={(e) => {
            const value = e.target.value;
            setDocumentName(value);
            if (documentNameError) {
              validateDocumentName(value);
            }
          }}
          onBlur={() => validateDocumentName(documentName)}
          sx={{ mb: 2 }}
          error={!!documentNameError}
          helperText={documentNameError || ""}
          required
          inputProps={{ maxLength: 120 }}
        />
      )}
      
      <Controller
        name={name}
        control={control}
        rules={validationRule}
        render={({ field }) => (
          <DragDropFileUpload
            name={name}
            value={value}
            error={!!errors}
            helperText={helptext}
            onFileSelect={(file) => {
              if (requireDocumentName && !validateDocumentName(documentName)) {
                showToast("Please enter a valid document name before uploading.", "error");
                return;
              }
              field.onChange(file);
              handleFileChange(file);
            }}
            multiple={multiple}
            disabled={requireDocumentName && (!documentName.trim() || !!documentNameError)}
          />
        )}
      />
    </Box>
  );
};

export default DocumentUploadSection;
